<script>
    import JobCard from "@buhl_ui/buhl_core/bc_news/joboffercards/lib/jobcard/JobCard.svelte";

    let { jobCards, latitude, longitude, headline } = $props();
</script>

<!--ganz Unten Zeigen untereinander-->
<div class="container p-lg-4">
    {#if jobCards.length > 0}
        <div class="row g-2 m-lg-5 gx-5">
            <h2 class="hp_headline-small mb-hp_smallest">{headline}</h2>
            {#each jobCards as job, i}
                <div class="col-12 col-md-6">
                    <JobCard
                        title={job.title}
                        is_ship={job.is_ship}
                        company={job.company}
                        employment_mode={job.employment_mode}
                        category={job.trade_group}
                        location={job.city}
                        logo={job.company_logo}
                        url={job.url}
                        {latitude}
                        {longitude}
                        index={i}
                        layout="down"
                        title_count={50}
                        trancate_count={50}
                    />
                </div>
            {/each}
        </div>
    {:else}
        <p class="text-center py-5">Keine Stellenangebote gefunden.</p>
    {/if}
</div>
